export default __webpack_public_path__ + "static/media/linus4.67b258a3.webp";